import { render } from "./InspecoesPrimeiraPeca.vue?vue&type=template&id=39cfa7dc&scoped=true"
import script from "./InspecoesPrimeiraPeca.vue?vue&type=script&lang=js"
export * from "./InspecoesPrimeiraPeca.vue?vue&type=script&lang=js"

import "./InspecoesPrimeiraPeca.vue?vue&type=style&index=0&id=39cfa7dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39cfa7dc"]])

export default __exports__